import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from '~/api/api.js';
import upload from '~/components/upload.vue';
import isButton from '~/components/button.vue';
import moment from 'moment';
var miniToastr = void 0;
var Datepicker = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
  Datepicker = require('vuejs-datepicker');
}
var userData = '';
export default {
  middleware: ['auth', 'authorizeAdminAndEngineer'],
  mounted: function mounted() {
    miniToastr.init();
  },

  notifications: {
    showLoginError: {
      title: '',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          params = _ref.params,
          error = _ref.error;
      var l, taskModel;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              l = store.state.authUser;

              userData = l;
              _context.next = 4;
              return API.setToken(userData.tokenID);

            case 4:
              _context.next = 6;
              return API.getTaskDetail(params.id);

            case 6:
              taskModel = _context.sent;

              if (!(taskModel.data.flag === false)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt('return', error({ statusCode: 401, message: taskModel.data.message }));

            case 9:
              return _context.abrupt('return', {
                dataID: params.id,
                tokenData: userData,
                //   listPartner: partner.data.datas.results,
                taskModel: taskModel.data.datas,
                //   files: files.data.datas,
                projectFile: ''
              });

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      taskModel: '',
      listTask: [],
      tokenData: userData,
      listPartner: '',
      vendorData: ''
    };
  },

  methods: {
    updateTask: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return API.setToken(this.tokenData.tokenID);

              case 2:
                _context2.next = 4;
                return API.EditTask(this.taskModel);

              case 4:
                result = _context2.sent;

                if (!(result.data.flag === true)) {
                  _context2.next = 10;
                  break;
                }

                this.showSuccess({ message: result.data.message });
                window.location.href = '/project/' + this.taskModel.projectID;
                _context2.next = 13;
                break;

              case 10:
                this.showLoginError({ message: result.data.message });
                this.$refs.btn.enabled();
                return _context2.abrupt('return', false);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateTask() {
        return _ref3.apply(this, arguments);
      }

      return updateTask;
    }(),

    selectVendor: function selectVendor() {
      var vendID = this.taskModel.vendorID;
      var index = this.listPartner.findIndex(function (x) {
        return x.id === vendID;
      });
      var data = this.listPartner[index];

      this.taskModel.vendorID = data.id;
      this.taskModel.vendorName = data.firstName;
    }
  },
  watch: {
    'taskModel.estStartDate': function taskModelEstStartDate() {
      this.taskModel.estStartDate = moment(this.taskModel.estStartDate).format('YYYY-MM-DD');
    },
    'taskModel.estFinishDate': function taskModelEstFinishDate() {
      this.taskModel.estFinishDate = moment(this.taskModel.estFinishDate).format('YYYY-MM-DD');
    }
  },
  components: {
    upload: upload,
    isButton: isButton,
    Datepicker: Datepicker
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/tasks/edit/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/tasks/edit/_id.vue
// module chunks = 36